{
	let wid = document.documentElement.clientWidth||document.body.innerWidth;
	document.documentElement.style.fontSize = wid/1920*100+"px";
}


// WEBPACK FOOTER //
// ./src/assets/js/remStyle.js